import { Save } from "@ortho-next/nextray-core";
import { BufferGeometry, Mesh, MeshBasicMaterial, ShapeGeometry } from "three";

export class BlackPlane extends Mesh {
  @Save("attributes.position", "attributes.normal", "attributes.uv", "index")
  public declare geometry: ShapeGeometry; //override
  public declare material: MeshBasicMaterial; //override

  public onAfterRestore = () => {
    this.geometry.computeBoundingSphere();
  }

  constructor() {
    super(new BufferGeometry(), new MeshBasicMaterial({ color: 0x000000 }));
    this.interceptedByRaycaster = false;
    this.name = "BlackPlane";
  }

  public setGeometry(geometry: ShapeGeometry) {
    this.geometry.dispose();
    this.geometry = geometry;
  }

}
